import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { User } from "@/types/users";

interface UserAvatarProps {
  user?: User;
  className?: string;
  fallbackClassName?: string;
}

export const UserAvatar = ({ user, className = "h-8 w-8", fallbackClassName }: UserAvatarProps) => {
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(part => part[0])
      .join('')
      .toUpperCase();
  };

  return (
    <Avatar className={className}>
      <AvatarImage 
        src={user?.avatar} 
        alt={user?.name || "User avatar"}
      />
      <AvatarFallback 
        className={fallbackClassName || "bg-primary/10 text-primary font-medium"}
      >
        {user?.name ? getInitials(user.name) : "U"}
      </AvatarFallback>
    </Avatar>
  );
}; 